import { Box, Stack, StackProps } from '@mui/material';

export default function ViewContainer(props: Readonly<StackProps>) {
    const { children, ...rest } = props;

    return (
        <Box
            sx={{
                overflow: 'auto',
                // Reserve space for scrollbar to prevent content shifting
                overflowX: 'hidden',
                scrollbarGutter: 'stable',
                width: '100%',
            }}
        >
            <Stack
                direction="column"
                spacing={1}
                {...rest}
                sx={[
                    {
                        display: 'flex',
                        flex: 1,
                        height: '100%',
                    },
                    ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
                ]}
            >
                {children}
            </Stack>
        </Box>
    );
}
